
const configUrl = {
  BASE_API_URL: 'https://api.qa.bingotalk.cn/', // 模块一接口地址
  BASE_ADMIN_URL: 'https://admin.qa.bingotalk.cn/', // 模块一接口地址
  BASE_CLASSPRO_URL: 'https://qa.binguoketang.com/#/edit/course',
  VUE_APP_PARENT: 'https://qa.binguoketang.com'
}
export default configUrl
